import { success } from 'toastr';
import {
  FETCH_REIMBURSEMENT_HEADS_REQUEST,
  FETCH_REIMBURSEMENT_HEADS_SUCCESS,
  FETCH_REIMBURSEMENT_HEADS_FAILURE,
  SAVE_REIMBURSEMENT_HEAD_REQUEST,
  SAVE_REIMBURSEMENT_HEAD_SUCCESS,
  SAVE_REIMBURSEMENT_HEAD_FAILURE,
  CHANGE_REIMBURSEMENT_HEAD_STATUS_REQUEST,
  CHANGE_REIMBURSEMENT_HEAD_STATUS_SUCCESS,
  CHANGE_REIMBURSEMENT_HEAD_STATUS_FAILURE,
  FETCH_REIMBURSEMENT_SUBHEADS_REQUEST,
  FETCH_REIMBURSEMENT_SUBHEADS_SUCCESS,
  FETCH_REIMBURSEMENT_SUBHEADS_FAILURE,
  SAVE_REIMBURSEMENT_SUBHEAD_REQUEST,
  SAVE_REIMBURSEMENT_SUBHEAD_SUCCESS,
  SAVE_REIMBURSEMENT_SUBHEAD_FAILURE,
  CHANGE_REIMBURSEMENT_SUBHEAD_STATUS_REQUEST,
  CHANGE_REIMBURSEMENT_SUBHEAD_STATUS_SUCCESS,
  CHANGE_REIMBURSEMENT_SUBHEAD_STATUS_FAILURE,
  FETCH_REIMBURSEMENT_MAPPED_HEADS_REQUEST,
  FETCH_REIMBURSEMENT_MAPPED_HEADS_SUCCESS,
  FETCH_REIMBURSEMENT_MAPPED_HEADS_FAILURE,
  CHANGE_MAPPED_HEAD_STATUS_FAILURE,
  SAVE_MAPPED_HEAD_FAILURE,
  FETCH_MAPPED_HEADS_FAILURE,
  CHANGE_MAPPED_HEAD_STATUS_SUCCESS,
  FETCH_MAPPED_HEADS_REQUEST,
  SAVE_MAPPED_HEAD_REQUEST,
  CHANGE_MAPPED_HEAD_STATUS_REQUEST,
  FETCH_MAPPED_HEADS_SUCCESS,
  SAVE_MAPPED_HEAD_SUCCESS,
  FETCH_REIMBURSEMENT_GRID_HEADS_REQUEST,
  FETCH_REIMBURSEMENT_GRID_HEADS_SUCCESS,
  FETCH_REIMBURSEMENT_GRID_HEADS_FAILURE,
  FETCH_REIMBURSEMENT_MAPPED_SUB_HEADS_REQUEST,
  FETCH_REIMBURSEMENT_MAPPED_SUB_HEADS_SUCCESS,
  FETCH_REIMBURSEMENT_MAPPED_SUB_HEADS_FAILURE,
} from './actionTypes';

const initialState = {
  loading: false,
  masterheads: [],
  mastersubheads: [],
  mappedheads: [],
  mappedheadslist: [],
  mappedsubheads: [],
  gridheads: [],
  error: null,
  success: false,
};

const reimbursementMasterReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REIMBURSEMENT_HEADS_REQUEST:
    case SAVE_REIMBURSEMENT_HEAD_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case FETCH_REIMBURSEMENT_HEADS_SUCCESS:
      return { ...state, loading: false, masterheads: action.payload, success: false };

    case FETCH_REIMBURSEMENT_HEADS_FAILURE:
    case SAVE_REIMBURSEMENT_HEAD_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case SAVE_REIMBURSEMENT_HEAD_SUCCESS:
      return { ...state, loading: false, success: true };

    case CHANGE_REIMBURSEMENT_HEAD_STATUS_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case CHANGE_REIMBURSEMENT_HEAD_STATUS_SUCCESS:
      return { ...state, loading: false, success: true };

    case CHANGE_REIMBURSEMENT_HEAD_STATUS_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case FETCH_REIMBURSEMENT_SUBHEADS_REQUEST:
      return { ...state, loading: true, success: false };

    case FETCH_REIMBURSEMENT_SUBHEADS_SUCCESS:
      return { ...state, loading: false, mastersubheads: action.payload, success: false };

    case FETCH_REIMBURSEMENT_SUBHEADS_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case SAVE_REIMBURSEMENT_SUBHEAD_REQUEST:
      return { ...state, loading: true, success: false };

    case SAVE_REIMBURSEMENT_SUBHEAD_SUCCESS:
      return { ...state, loading: false, success: true };

    case SAVE_REIMBURSEMENT_SUBHEAD_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case CHANGE_REIMBURSEMENT_SUBHEAD_STATUS_REQUEST:
      return { ...state, loading: true, success: false };

    case CHANGE_REIMBURSEMENT_SUBHEAD_STATUS_SUCCESS:
      return { ...state, loading: false, success: true };

    case CHANGE_REIMBURSEMENT_SUBHEAD_STATUS_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case FETCH_REIMBURSEMENT_MAPPED_HEADS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false
      };
    case FETCH_REIMBURSEMENT_MAPPED_HEADS_SUCCESS:
      return {
        ...state,
        loading: false,
        mappedheads: action.payload,
        success: false
      };
    case FETCH_REIMBURSEMENT_MAPPED_HEADS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false
      };

    case FETCH_MAPPED_HEADS_REQUEST:
    case SAVE_MAPPED_HEAD_REQUEST:
    case CHANGE_MAPPED_HEAD_STATUS_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case FETCH_MAPPED_HEADS_SUCCESS:
      return { ...state, loading: false, mappedheadslist: action.payload };

    case SAVE_MAPPED_HEAD_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };

    case CHANGE_MAPPED_HEAD_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };

    case FETCH_MAPPED_HEADS_FAILURE:
    case SAVE_MAPPED_HEAD_FAILURE:
    case CHANGE_MAPPED_HEAD_STATUS_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case FETCH_REIMBURSEMENT_GRID_HEADS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false
      };
    case FETCH_REIMBURSEMENT_GRID_HEADS_SUCCESS:
      return {
        ...state,
        loading: false,
        gridheads: action.payload,
        success: false
      };
    case FETCH_REIMBURSEMENT_GRID_HEADS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false
      };

    case FETCH_REIMBURSEMENT_MAPPED_SUB_HEADS_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case FETCH_REIMBURSEMENT_MAPPED_SUB_HEADS_SUCCESS:
      return { ...state, loading: false, mappedsubheads: action.payload, success: false };

    case FETCH_REIMBURSEMENT_MAPPED_SUB_HEADS_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    default:
      return state;
  }
};

export default reimbursementMasterReducer;
